/** Shared by the plugin manifest (plugin/index.ts) and the in-game Settings popup's version display (WP-VIS.10). */
export const WATERSORT_VERSION = '1.0.0';
